// Step 3
// Payment Details Step
import { useState, useEffect } from 'react';
import Product from '../product-component/product';
import Payment from '../payment-component/payment';

import americanExpress from '../../assets/images/payment-american-express.png';
import mastercard from '../../assets/images/payment-mastercard.png';
import visa from '../../assets/images/payment-visa.png';

export default function PaymentStep({selectMembership, isRenewalPage, businessCategories, currentStep, languages, locationData, stepNo, localStorageDatas, goNextStep, couponObj, isUserLogged}) {
  
  //const [paymentOption, setPaymentOption] = useState('option1')

  function handleChange(e) {
    //setPaymentOption(e.target.value)
  }

  if (currentStep !== stepNo) {
      return null
    } 
    return(
      <div>
          <Payment 
            selectMembership  = {selectMembership} 
            locationData      = {locationData} 
            localStorageDatas = {localStorageDatas} 
            goNextStep        = {goNextStep} 
            couponObj         = {couponObj}
            isUserLogged      = {isUserLogged}
            businessCategories = {businessCategories}
            isRenewalPage     = {isRenewalPage}
            languages = {languages}
          />
          {/* <form>
            <div className="radio">
              <label>
                <input type="radio" name="input1" value="option1" checked={paymentOption === 'option1'} onChange={handleChange}/>
                <span><img src={americanExpress} /></span>
                <span><img src={mastercard} /></span>
                <span><img src={visa} /></span>
              </label>
            </div>
            <div className="radio">
              <label>
                <input type="radio" name="input2" value="option2" checked={paymentOption === 'option2'} onChange={handleChange}/>
                Option 2
              </label>
            </div>
            <div className="radio">
              <label>
                <input type="radio" name="input3" value="option3" checked={paymentOption === 'option3'} onChange={handleChange}/>
                Option 3
              </label>
            </div>
          </form> */}
      </div>
    );
}